export default __webpack_public_path__ + "static/media/ai_face_tracking.e7b4143f.svg";